import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import RecordMeetingSection from "src/features/account/RecordMeetingSection";
import BaseHeader from "src/pages/layout/Header";
import "./Header.scss";
const Header = () => {
    return (_jsxs(BaseHeader, { className: 'home-header', children: [_jsx(PageNavBreadcrumbs, {}), _jsx(RecordMeetingSection, {})] }));
};
export default Header;
